import { Vue } from 'vue-property-decorator'
import PortalVue from 'portal-vue'

Vue.use(PortalVue)
